import Gutters1Story from "./gutters1story.svg";
import Gutters2Story from "./gutters2story.svg";
import Gutters3Story from "./gutters3story.svg";

const icons = {
  gutters1story: Gutters1Story,
  gutters2story: Gutters2Story,
  gutters3story: Gutters3Story,
};

export default icons;
